import { CurrentPolicyPageSchema } from "@/schema/renewal-page/current-policy-page.schema";
import {
  RenewalLoadingSchemaType,
  RenewalRightPanelContentSchemaType,
  RenewalDashboardLeftMenuSchema,
  RenewalPageAreaType,
  RenewalLandingPageHeaderType,
  RenewalMTAQuoteCreationModalType,
} from "@/schema/renewal-page/page-content.schema";

export function transformRenewalLoadingData(data: RenewalLoadingSchemaType) {
  return {
    title: data.title,
    mobileContent: Object.values(data.mobileContent).map((item) => item.field),
    desktopContent: Object.values(data.desktopContent).map(
      (item) => item.field
    ),
  };
}
export function transformRenewalRightPanelData(
  data: RenewalRightPanelContentSchemaType
) {
  return {
    trustPilotUrl: data.trustPilotUrl,
    brandName: data.brandName,
    menuItems: Object.values(data.menuItems).map((item) => item),
  };
}

export function transformRenewalLeftData(data: RenewalDashboardLeftMenuSchema) {
  return {
    menuItems: Object.values(data?.menuItems).map((menuItem) => menuItem),
  };
}

export function transformRenewalMiddlePanelData(data: RenewalPageAreaType) {
  return {
    policyDetailsAccordionData: data.policyDetailsAccordionArea[0],
    travellersAccordionData: data.travellersAccordionArea[0],
    contactDetailsAccordionData: data.contactDetailsAccordionArea[0],
    policyExtrasAccordionData: data.policyExtrasAccordionArea[0],
    medicalAccordionData: data.medicalAccordionArea[0],
  };
}

export function transformRenewalCurrentPolicyData(
  data: CurrentPolicyPageSchema
) {
  return {
    headerArea: data.headerArea[0],
    policiesArea: data.policiesArea[0],
  };
}

export function transformRenewalHeaderData(data: RenewalLandingPageHeaderType) {
  return {
    title: data.title,
    bottomTextMobileLoaded: data.bottomTextMobileLoaded,
    bottomTextDesktopLoaded: data.bottomTextDesktopLoaded,
    bottomTextTabletLoaded: data.bottomTextTabletLoaded,
    bottomTextMobileLoading: data.bottomTextMobileLoading,
    bottomTextDesktopLoading: data.bottomTextDesktopLoading,
    bottomTextTabletLoading: data.bottomTextTabletLoading,
  };
}

export function transformRenewalMTAQuoteCreateModalData(
  data: RenewalMTAQuoteCreationModalType
) {
  return {
    errorModalTitle: data.errorModalTitle,
    errorModalContent: data.errorModalContent,
    errorModalCTAButtonLabel: data.errorModalCTAButtonLabel,
    menuItems: Object.values(data?.menuItems).map((menuItem) => menuItem),
  };
}
